function BrowserslistError (message) {
  this.name = 'BrowserslistError'
  this.message = message || ''
  this.browserslist = true
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, BrowserslistError)
  }
}

BrowserslistError.prototype = Error.prototype

module.exports = BrowserslistError



//////////////////
// WEBPACK FOOTER
// ./node_modules/browserslist/error.js
// module id = pLaa
// module chunks = 81